(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('LibraryPickerCtrl', libraryPickerCtrl);

    function libraryPickerCtrl($scope, LibrariesAPIService, LibrariesUtilService, $mdDialog, blockUI) {
        $scope.colorModeStrings = ['RGB', 'CMYK'];
        $scope.filteredLibraries = [];
        $scope.currentPage = 1;
        $scope.numPerPage = 15;
        $scope.maxSize = 5;
        $scope.begin = 0;
        $scope.librariesCount = 0;
        $scope.searchString = '';

        // Get library picker settings
        $scope.viewerSettings = LibrariesUtilService.getCurrentPickerSettings();
        $scope.libraryType = $scope.viewerSettings.libraryType;

        $scope.$watch('currentPage + numPerPage', function () {
            $scope.begin = ($scope.currentPage - 1) * $scope.numPerPage;
            $scope.getLibraries();
        });

        $scope.getLibraries = function () {
            blockUI.start('Loading libraries');
            // Remove spaces
            $scope.searchString = $scope.searchString.trim();
            const getLibArguments = {
                searchString: $scope.searchString,
                type: $scope.libraryType,
                deleted: false,
                excludeLibrariesWithCategories: $scope.viewerSettings.excludeLibrariesWithCategories
            };

            LibrariesAPIService.getLibraries({
                ...getLibArguments,
                from: $scope.begin,
                num: $scope.numPerPage
            })
                .then(function (data) {
                    $scope.filteredLibraries = data;
                    LibrariesAPIService.getLibrariesCount(getLibArguments)
                        .then(function (count) {
                            $scope.librariesCount = count;
                            blockUI.stop();
                        })
                        .catch(function (error) {
                            window.rumReportError(error);
                            blockUI.stop();
                        });
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                });
        };

        $scope.selectLibrary = function (library) {
            // Close the dialog passing the selected library
            $mdDialog.hide(library);
        };

        $scope.clearSearchString = function () {
            $scope.searchString = '';
        };
    }
})();
